<template>
  <div
    class="deal-card position-relative"
    :disabled="!isDraggable"
    @dragstart="onDragStart"
    :data-ticket="JSON.stringify(deal)"
    @click="openDealDataCard"
    :style="{
      borderLeft:
        deal.responsible_user && getUserColor(deal.responsible_user?.id)
          ? `3px solid ${getUserColor(deal.responsible_user?.id)}`
          : '',
      background: deal.highlighted ? '#ffdc73' : '#fff',
    }"
  >
    <div
      v-if="deal.unread_count && deal.unread_count > 0"
      class="unread_count px-2 bg-danger rounded position-absolute mb-2 me-1"
    >
      <span class="text-white">{{ deal.unread_count }}</span>
    </div>
    <div
      class="row"
      :style="{
        background: deal.highlighted
          ? '#ffdc73'
          : 'linear-gradient(to left, white, rgb(231, 227, 227))',
      }"
    >
      <!-- العنوان -->
      <div
        class="col-12 d-flex justify-content-between align-items-center mb-1 p-0"
      >
        <span class="ms-2 fw-semibold fs-7 d-flex align-items-center">
          <country-flag-avatar
            v-if="deal.phone"
            :phone="deal.phone"
            style="width: 22px; height: 20px !important"
          />
          {{ deal.name.length > 20 ? deal.name.slice(0, 20) + "…" : deal.name }}
          <span v-if="ticketValue">
            <i class="fa-solid fa-fire text-danger ms-2"></i>
          </span>
        </span>
        <span class="d-flex align-items-center">
          <button class="btn btn-link m-0 p-0" @click.stop="handleHighlight">
            <i
              class="fa-solid fa-bookmark position-absolute"
              :class="deal.highlighted ? 'text-white' : 'text-warning'"
              style="right: 8px; top: 1px; font-size: 18px"
            ></i>
          </button>
        </span>
      </div>

      <!-- الهاتف والواتساب -->
      <div
        class="col-12 d-flex justify-content-between align-items-center fs-7 mb-1 p-0"
      >
        <span
          class="fw-normal text-dark phone-number d-flex align-items-center"
          @click.stop="copyPhoneNumber"
          :title="t('click-to-copy')"
        >
          <span class="d-flex align-items-center">
            <i class="ms-2 fa-solid fa-phone me-1 opacity-100 text-dark"></i>
            {{
              deal.phone
                ? can_view_full_phone
                  ? deal.phone
                  : deal.phone.slice(0, -2) + "**"
                : "************"
            }}
          </span>
          <i class="fa-solid fa-copy ms-1"></i>
        </span>
        <span class="fw-normal text-dark fs-7">
          <i :class="getIcon(deal.source_id)"></i>
        </span>
      </div>

      <!-- النجوم -->
      <div
        class="col-12 fs-8 mb-1 p-0 d-flex justify-content-between align-items-center"
      >
        <div class="">
          <span class="ms-2 text-secondary"
            >{{ t("kanban-deal-label-rating") }}:
          </span>
          <template v-for="index in 7" :key="index">
            <i
              class="fa-solid fa-star"
              :class="
                index <= (deal.rating || 0) ? 'text-gold' : 'text-secondary'
              "
            ></i>
          </template>
        </div>
        <span class="text-dark fs-7" v-if="!showCalendarDrag">
          {{ deal.view_count }} <i class="fa-solid fa-eye"></i>
        </span>
        <span
          v-if="showCalendarDrag"
          class="deal-card-calendar"
          draggable="true"
          :data-ticket="JSON.stringify(deal)"
          style="cursor: grab"
          title="اسحب إلى التقويم"
        >
          <i class="fa fa-calendar-plus text-primary fs-6"></i>
        </span>
      </div>

      <!-- persuasion progress  -->
      <!-- <div class="col-12 persuasion-progress">
        <div class="d-flex align-items-center gap-1" style="font-size: 12px">
          <i class="fa-solid fa-bullseye text-secondary"></i>
          <span class="fw-medium text-secondary">
            {{ deal.persuasion_status || 85 }}%
          </span>
          <div class="progress flex-grow-1" style="height: 6px">
            <div
              class="progress-bar rounded-5"
              :class="getPersuasionColorClass(deal.persuasion_status)"
              role="progressbar"
              :style="{ width: `${deal.persuasion_status || 85}%` }"
              :aria-valuenow="deal.persuasion_status || 85"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </div> -->

      <!-- <div
        class="d-flex gap-1 align-items-center p-0 flex-wrap"
        v-if="deal.tags && deal.tags.length && userRole !== 'sales'"
      >
        <span
          v-for="tag in deal.tags"
          :key="tag.id"
          class="p-0 badge p-1"
          :style="{
            backgroundColor: tag.color_code,
            color: getContrastColor(tag.color_code),
          }"
          data-toggle="tooltip"
          data-placement="top"
          :title="tag.name"
        >
          <i :class="`fa-solid fa-${tag.icon} me-1`"></i>
          <span class="fw-normal">{{
            tag.name.length > 20 ? tag.name.slice(0, 20) + "…" : tag.name
          }}</span>
        </span>
      </div> -->

      <div
        v-if="$route.path === '/crm-tasks' && currentStageName"
        class="d-flex align-items-center p-0 mt-1"
      >
        <span
          class="badge fw-medium text-white py-1 px-2"
          :style="{
            backgroundColor: currentStageColor,
            fontSize: '11px',
          }"
        >
          <i :class="`fa-solid fa-${currentStageIcon} me-1`"></i>
          {{
            currentStageName.length > 20
              ? currentStageName.slice(0, 20) + "…"
              : currentStageName
          }}
        </span>
      </div>
    </div>

    <!-- ملاحظة إدارية -->
    <!-- <div v-if="deal.has_admin_comment" class="col-12 pt-1">
      <div class="notes">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span class="px-2">{{ t("kanban-deal-alert-attention") }}</span>
        <i class="fa-solid fa-triangle-exclamation"></i>
      </div>
    </div> -->

    <!-- التواريخ -->
    <div class="col-12 mt-2 d-flex justify-content-between align-items-center">
      <span
        class="text-dark fs-7 bg-secondary-50 rounded px-1"
        v-show="can_view_created_at"
        ><i class="ms-1 mt-1 fa-solid fa-square-plus fs-6"></i>
        {{ formatDate(deal.created_at) }}</span
      >
      <span
        class="text-dark fs-7 bg-secondary-50 rounded px-1"
        v-show="!can_view_created_at"
        ><i class="ms-1 mt-1 fa-solid fa-user fs-6"></i>
        {{ formatDate(deal.last_assigned_at) }}</span
      >
      <span class="text-dark fs-7 bg-secondary-50 rounded px-1"
        ><i class="ms-1 mt-1 fa-solid fa-square-pen fs-6"></i>
        {{ formatDate(deal.updated_at) }}</span
      >
    </div>
    <div
      class="col-12 mt-1"
      v-if="can_view_responsible_user && deal.responsible_user"
    >
      <span
        class="badge fw-medium text-white py-1 px-2"
        :style="{
          backgroundColor: deal.responsible_user?.color_code ?? '#292929',
          color: getContrastColor(
            deal.responsible_user?.color_code || '#292929'
          ),
        }"
        >{{ deal.responsible_user?.name }}</span
      >
    </div>
    <div
      class="mt-1"
      v-if="deal.has_admin_comment"
      :title="t('kanban-deal-alert-attention')"
    >
      <i class="mx-1 fa-solid fa-comment-dots fs-6 text-warning"></i>
      <span class="fs-7">{{ t("kanban-deal-alert-attention") }}</span>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useNotificationStore } from "@/stores/notificationStore";

import { computed } from "vue";
import CountryFlagAvatar from "@/components/whatsapp/WhatsAppModalSidebarLeftCountryFlagAvatar.vue";
import Cookies from "js-cookie";
import { useDealStore } from "@/stores/DealStore";
import { usePermissionStore, PERMISSIONS } from "@/stores/PermissionStore";

export default {
  name: "CrmDealKanbanBoardDealsTicketCard",
  props: {
    deal: {
      type: Object,
      required: true,
    },
    stageId: {
      type: [String, Number],
      default: null,
    },
    allStages: {
      type: Array,
      default: () => [],
    },
    showCalendarDrag: {
      type: Boolean,
      default: false,
    },
    isDraggable: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    CountryFlagAvatar,
  },
  setup(props, { emit }) {
    const notificationStore = useNotificationStore();
    const permissionStore = usePermissionStore();
    const can_view_responsible_user = permissionStore.hasPermission(
      PERMISSIONS.VIEW_RESPONSIBLE_USER
    );
    const can_view_created_at = permissionStore.hasPermission(
      PERMISSIONS.READ_DEALS_CREATED_AT
    );
    const can_view_full_phone = permissionStore.hasPermission(
      PERMISSIONS.READ_FULL_PHONE
    );
    const userRole = Cookies.get("user_role");
    const { t } = useI18n();
    const dealStore = useDealStore();
    const ticketValue = computed(() => {
      const dealCreatedDate = new Date(props.deal.created_at);
      const today = new Date();
      const differenceInDays =
        (today - dealCreatedDate) / (1000 * 60 * 60 * 24);
      return differenceInDays <= 30;
    });
    const formatDate = (dateString) => {
      if (!dateString) return "";

      const date = new Date(dateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(2);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    };
    const formatDateUpdate = (dateString) => {
      if (!dateString) return "";

      const date = new Date(dateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");

      return `${day}/${month}`;
    };
    const openDealDataCard = () => {
      dealStore.changeCurrentDeal(props.deal.id);
    };
    const getUserColor = (userId) => {
      return localStorage.getItem(`user_${userId}_color`) || "#292929";
    };
    const borderRight = (userId) => {
      return localStorage.getItem(`user_${userId}_color`) || "#292929";
    };
    const getIcon = (sourceId) => {
      switch (sourceId) {
        case 1:
          return "fab fa-facebook";
        case 2:
          return "fab fa-whatsapp";
        case 3:
          return "fab fa-google";
        case 4:
          return "fab fa-instagram";
        case 5:
          return "fab fa-twitter";
        case 6:
          return "fab fa-tiktok";
        case 7:
          return "fab fa-snapchat";
        case 8:
          return "fa-brands fa-vk";
        case 9:
          return "fab fa-telegram";
        case 10:
          return "fa-solid fa-recycle";
        case 11:
          return "fa-solid fa-recycle";
        case 12:
          return "fa-solid fa-recycle";
        case 13:
          return "fa-solid fa-recycle";
        case 14:
          return "fa-solid fa-recycle";
        case 15:
          return "fa-solid fa-recycle";
        case 16:
          return "fa-solid fa-recycle";
        default:
          return "fa-solid fa-circle-question";
      }
    };
    const tagIcon = (tagName) => {
      switch (tagName.toLowerCase()) {
        case "new":
          return "fa-plus";
        case "hot":
          return "fa-fire";
        case "idle":
          return "fa-snowflake";
        case "medicine":
          return "fa-capsules";
        case "no response":
          return "fa-phone-slash";
        case "stopped responding":
          return "fa-moon";
        case "reference":
          return "fa-street-view";
        case "re-contact":
          return "fa-repeat";
        case "low potential":
          return "fa-user-slash";
        case "trash":
          return "fa-trash";
        default:
          return "fa-recycle";
      }
    };
    const getContrastColor = (hexColor) => {
      const r = parseInt(hexColor.slice(1, 3), 16);
      const g = parseInt(hexColor.slice(3, 5), 16);
      const b = parseInt(hexColor.slice(5, 7), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 170 ? "#000000" : "#FFFFFF";
    };
    const copyPhoneNumber = async () => {
      try {
        await navigator.clipboard.writeText(props.deal.phone);
        notificationStore.success(t("phone-copied"));
      } catch (err) {
        console.error(err);
        notificationStore.error(err.message);
      }
    };
    const getPersuasionColorClass = (persuasion_status) => {
      const status = persuasion_status || 85;
      if (status <= 25) return "bg-danger";
      if (status <= 50) return "bg-warning";
      if (status <= 75) return "bg-info";
      return "bg-success";
    };

    const currentStage = computed(() => {
      if (!props.stageId || !props.allStages || props.allStages.length === 0) {
        return null;
      }
      const stage = props.allStages.find((s) => s.id == props.stageId);
      return stage || null;
    });

    const currentStageName = computed(() => {
      return currentStage.value ? currentStage.value.name : "";
    });

    const currentStageColor = computed(() => {
      return currentStage.value ? currentStage.value.color_code : "#17a2b8";
    });

    const currentStageIcon = computed(() => {
      return currentStage.value ? currentStage.value.icon : "layer-group";
    });
    const handleHighlight = async () => {
      emit("toggle-highlight", props.deal.id);
    };

    const onDragStart = (event) => {
      event.dataTransfer.setData(
        "application/json",
        JSON.stringify({
          id: props.deal.id,
          name: props.deal.name,
          stage_id: props.deal.stage_id,
        })
      );
    };

    return {
      t,
      formatDate,
      openDealDataCard,
      getUserColor,
      borderRight,
      getIcon,
      tagIcon,
      getContrastColor,
      copyPhoneNumber,
      formatDateUpdate,
      getPersuasionColorClass,
      userRole,
      currentStageName,
      currentStageColor,
      currentStageIcon,
      handleHighlight,
      onDragStart,
      ticketValue,
      can_view_responsible_user,
      can_view_created_at,
      can_view_full_phone,
    };
  },
  methods: {},
};
</script>

<style scoped>
.deal-card {
  /* background: white; */
  border-radius: 8px;
  padding: 0.75rem;
  margin-bottom: 0.3rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  cursor: move;
  transition: all 0.3s ease;
}

.deal-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.notes {
  background-color: #fff3cd;
  color: #856404;
  border-radius: 4px;
  padding: 4px 8px;
  text-align: center;
  font-size: 0.875rem;
}

.text-gold {
  color: #ffd700;
}

.text-lightgray {
  color: #d3d3d3;
}

.fs-7 {
  font-size: 0.875rem;
}

.fs-8 {
  font-size: 0.75rem;
}

.row {
  border-radius: 6px 6px 0 0;
  padding: 8px;
  margin: -12px -12px 8px -12px;
}
.unread_count {
  bottom: 5px;
  right: 5px;
  font-size: 14px;
}
.bg-Tages {
  background-color: rgba(76, 74, 74, 0.453);
}

.bg-Tages i {
  margin-inline-end: 1px;
}

.phone-number {
  cursor: pointer;
  transition: all 0.2s ease;
}

.phone-number i {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.phone-number:hover i {
  opacity: 1;
}

.persuasion-progress {
  padding: 0 4px;
}

.persuasion-progress .progress {
  background-color: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
  margin: 0;
}

.persuasion-progress .progress-bar {
  transition: width 0.3s ease;
}

.bg-secondary-50 {
  background-color: #f3f3f3;
}
</style>
